import React from 'react'
import { useTranslation } from 'next-i18next'
import { IntegrationPurchase } from 'src/core/models'
import styles from './IntegrationPurchaseCertificateColumn.module.scss'
import { BlockOutlined, DollarOutlined, FileProtectOutlined } from '@ant-design/icons'
import IntegrationPurchaseCertificateLink from './IntegrationPurchaseCertificateLink/IntegrationPurchaseCertificateLink'

const IntegrationPurchaseCertificateColumn: React.FC<{ purchase: IntegrationPurchase }> = ({ purchase }) => {
  const { t } = useTranslation()

  const certificates = {
    blockchain: purchase.certificate_url,
    cancelation: purchase.cancellation_certificate,
    invoice: purchase.credit_offsetting_receipt
  }

  return <div className={styles.content}>

    {/* Blockchain */}
    <IntegrationPurchaseCertificateLink
      icon={<BlockOutlined />}
      link={certificates.blockchain}
      title={t('Transactions.BlockchainCertificate')}
      disabled={certificates.blockchain === null}
      disabledTitle={t('Transactions.NoBlockchain')}
    />

    {/* Cancellation */}
    <IntegrationPurchaseCertificateLink
      icon={<FileProtectOutlined />}
      link={certificates.cancelation}
      title={t('Transactions.CancellationCertificate')}
      disabled={certificates.cancelation === null}
      disabledTitle={t('Transactions.NoCancellation')}
    />

    {/* Invoice */}
    <IntegrationPurchaseCertificateLink
      icon={<DollarOutlined />}
      link={certificates.invoice}
      title={t('Transactions.InvoiceCertificate')}
      disabled={certificates.invoice === null}
      disabledTitle={t('Transactions.NoInvoice')}
    />

  </div>
}

export default IntegrationPurchaseCertificateColumn
